<template>
  <b-overlay>
    <l-form-row
        v-for="node in nodes"
        :key="node.data"
        :choices="buildChoices(node)"
        :onchange="updateChoice"
        :type="getType(node)"></l-form-row>
  </b-overlay>
</template>

<script>
import LFormRow from "@/components/lFormRow.vue";

export default {
  name      : "lForm",
  components: {LFormRow},
  props     : ["tree"],
  data      : function() {
    const nodes = [this._props.tree.GetNode("/"),]
    return {
      nodes
    }
  },
  methods   : {
    getType(node) {
      const {meta} = (node.GetChildren() || [{}])[0]
      if (!meta) return ""
      switch (true) {
        case !!meta.img:
          return "card";
        case !!meta.list:
          return "select";
        default:
          return ""
      }
    },
    buildChoices(node) {
      return node.GetChildren().map(({data, meta}) => {
        return {text: data, ...meta}
      })
    },
    updateChoice({path}) {
      this.nodes = this._props.tree.GetBranch(path).filter(n => n.GetChildren().length > 0);
    }
  }
}
</script>

<style scoped>

</style>